export default __webpack_public_path__ + "static/media/terminal-de-consulta-gertec.eb313070.png";